<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../../Mixins/global'
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'

export default {
  components: { ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    simulationId: { type: Number, default: '' },
  },

  data() {
    return {
      availables: [],
      loaded: false,
    }
  },

  computed: {
    displayCompanyViewer() {
      return this.hasRole('ROLE_PROFITABILITY_SHOW')
    },
  },

  methods: {
    showModal() {
      this.setFields(this.simulationId)
    },
    setFields: function (id) {
      this.getJSON(`quotations/${id}/demands`).then(
        (json) => {
          this.$emit('loading')
          this.availables = json.availables
          if (this.availables.length == 0) {
            this.$emit('show-pop-up-request', true)
            return
          }
          this.loaded = true
          $('#modal-deals').modal('show')
        },
        (reason) => {
          alert(reason)
          this.$emit('loading')
        },
      )
    },

    sendAffect: function (id) {
      this.postJSON('quotations/' + this.simulationId + '/demands/' + id + '/affect', '', {}).then(
        (json) => {
          location.reload()
        },
        (reason) => {
          alert(reason)
        },
      )
    },

    sendReplay: function (id) {
      this.postJSON('quotations/' + this.simulationId + '/demands/' + id + '/replay', '', {}).then(
        (json) => {
          location.reload()
        },
        (reason) => {
          alert(reason)
        },
      )
    },

    showPopupRequest: function () {
      this.$emit('show-pop-up-request', true)
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-deals"
    id-modal-page="proposalbox"
    class-modal-dialog="modal-xl"
    title-t="simulation.popin.deal.title"
    e2e-modal="deals"
  >
    <template v-if="loaded" #body>
      <div v-if="availables.length != 0" class="mt-3" style="overflow-x: auto">
        <p>{{ $t('simulation.popin.deal.available') }}</p>
        <table class="table table-striped _table-bordered table-hover fs-16">
          <thead>
            <tr>
              <th>{{ $t('simulation.number') }}</th>
              <th class="modal-deal-desktop text-right" v-if="displayCompanyViewer">
                {{ $t('simulation.popin.deal.refinancerName') }}
              </th>
              <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.productName') }}</th>
              <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.demandNumber') }}</th>
              <th class="modal-deal-desktop text-right" v-if="displayCompanyViewer">
                {{ $t('simulation.popin.deal.amountDemand') }}
              </th>
              <th class="modal-deal-desktop text-right" v-if="displayCompanyViewer">
                {{ $t('simulation.popin.deal.amountAvailable') }}
              </th>
              <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.validity') }}</th>
              <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.status') }}</th>
              <th class="text-center">{{ $t('simulation.popin.decisionDeal.affect') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="available in availables" :key="available.id">
              <td class="modal-deal-desktop">
                <a
                  :href="'../devis/simulation.php?i=' + available.simulationId + '&p=devis&index=simulation'"
                  target="_blank"
                  >{{ available.simulationId }}</a
                >
              </td>
              <td class="modal-deal-desktop text-right" v-if="displayCompanyViewer">{{ available.refinancer.name }}</td>
              <td class="modal-deal-desktop text-right">{{ available.productType.name }}</td>
              <td class="modal-deal-desktop text-right">{{ available.demandNumber }}</td>
              <td class="modal-deal-desktop text-right" v-if="displayCompanyViewer">
                {{ $n(Number(available.finance.amount), 'integer') }}
              </td>
              <td class="modal-deal-desktop text-right" v-if="displayCompanyViewer">
                {{ $n(Number(available.outstanding.availableContracts), 'integer') }}
              </td>
              <td class="modal-deal-desktop text-right">{{ setDate(available.decisionValidity, 'date') }}</td>
              <td class="modal-deal-desktop text-right">
                {{ $t('simulation.status.' + available.status + '.label') }}
              </td>
              <td class="modal-deal-mobile">
                {{ available.productType.name }}<br />
                <div class="d-flex justify-content-between my-2" v-if="displayCompanyViewer">
                  <strong>{{ $t('simulation.popin.deal.amountDemand') }}</strong
                  >{{ $n(Number(available.finance.amount), 'integer') }}<br />
                </div>
                <div class="d-flex justify-content-between my-2" v-if="displayCompanyViewer">
                  <strong>{{ $t('simulation.popin.deal.amountAvailable') }}</strong
                  >{{ $n(Number(available.outstanding.availableContracts), 'integer') }}<br />
                </div>
                <div class="d-flex justify-content-between my-2">
                  <strong>{{ $t('simulation.popin.deal.validity') }}</strong
                  >{{ setDate(available.decisionValidity, 'date') }}<br />
                </div>
              </td>
              <td class="text-center">
                <button class="btn btn-success" @click="sendAffect(available.id)"><i class="fas fa-reply"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else #body>
      <div class="text-center mt-3">
        <div class="spinner-border" style="width: 5rem; height: 5rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template #footer>
      <ButtonAll margin="no" type="information" label="button.cancel" />
      <ButtonAll
        margin="no"
        type="validation"
        label="simulation.popin.request_force.button"
        @click="showPopupRequest"
      />
    </template>
  </ModalDialog>
</template>
